import React from 'react';
import {
  Map,
  useMap,
} from '@vis.gl/react-google-maps';
import MyFieldsAgvanceFieldBoundary from '../mapping/MyFieldsAgvanceFieldBoundary';

const CarbonScoringFieldMap = ({selectedFarmField}) => {

  const map = useMap();

  React.useEffect(() => {
    if (map === null || selectedFarmField === null) {
      return;
    }
    const polygons = selectedFarmField.GoogleMapFieldPolygons || [];
    if (polygons.length > 0 && window.google) {
      const bounds = new window.google.maps.LatLngBounds();
      polygons.forEach(polygon => {
        polygon.forEach(point => bounds.extend(point));
      });
      map.fitBounds(bounds, 20);
    }
    else if (selectedFarmField.geoCodedLatitude && selectedFarmField.geoCodedLongitude) {
      map.panTo({
        lat: selectedFarmField.geoCodedLatitude,
        lng: selectedFarmField.geoCodedLongitude,
      });
      map.setZoom(14);
    }
  }, [map, selectedFarmField]);

  return (
    <div style={{
      width: '100%',
      height: 260,
      borderRadius: 8,
      overflow: 'hidden',
    }}>
      <Map
        mapId='CARBON_SCORING_FIELD'
        defaultCenter={{
          lng: selectedFarmField?.geoCodedLongitude || -88.257311,
          lat: selectedFarmField?.geoCodedLatitude || 40.112519,
        }}
        defaultZoom={parseInt(process.env.REACT_APP_DEFAULT_MAP_ZOOM)}
        fullscreenControl={false}
        mapTypeControl={false}
        streetViewControl={false}
        mapTypeId='hybrid'>
        {
          selectedFarmField?.GoogleMapFieldPolygons?.map((polygon, index) => (
            <MyFieldsAgvanceFieldBoundary farmFieldPolygon={polygon} fillColor={null} key={index} />
          ))
        }
      </Map>
    </div>
  );
}

export default CarbonScoringFieldMap;
